(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dj-jar-finder"] && !Shopify.designMode) return;
  try {
    
function djfParseContents(description){
 const text=description.replace(/<[^>]+>/g,' ').replace(/&nbsp;/g,' ').replace(/\u00a0/g,' ');
 const number=(pattern)=>{const m=text.match(pattern);return m?{min:Number(m[1]),max:Number(m[2]||m[1])}:null};
 const q='(\\d+)\\s*(?:[–—-]\\s*(\\d+))?\\s*';
 const contents={necklaces:number(new RegExp(q+'(?:verrassings)?kettingen','i')),rings:number(new RegExp(q+'(?:verstelbare\\s+)?ringen','i')),earrings:number(new RegExp(q+'paar\\s+oorbellen','i')),bracelets:number(new RegExp(q+'armband(?:jes|en)','i'))};
 const names={necklaces:'(?:verrassings)?kettingen',rings:'(?:verstelbare\\s+)?ringen',earrings:'(?:een\\s+)?(?:paar\\s+)?oorbellen',bracelets:'armband(?:jes|en)'};
 for(const [kind,label] of Object.entries(names)){
  const only=new RegExp('(?:alleen|uitsluitend)\\s+(?:een\\s+mix\\s+van\\s+)?'+label,'i').test(text);
  if(only&&contents[kind])return Object.fromEntries(Object.keys(contents).map(t=>[t,t===kind?contents[t]:{min:0,max:0}]));
 }
 return Object.values(contents).every(Boolean)?contents:null;
}
function djfRank(products,prefs){
 return products.filter(p=>p.available&&p.contents&&p.price<=prefs.budget)
 .filter(p=>{const types=Object.keys(p.contents).filter(t=>p.contents[t].min>0);return prefs.kind==='mix'?types.length>1:types.length===1&&types[0]===prefs.kind})
 .filter(p=>prefs.metal==='any'||(p.colors.includes(prefs.metal)&&!p.colors.includes(prefs.metal==='gold'?'silver':'gold')))
 .filter(p=>prefs.accent==='any'||(prefs.accent==='pearl'?p.colors.some(c=>['white','white-with-pearl'].includes(c)):p.colors.includes(prefs.accent)))
 .map(p=>({...p,matched:[],score:prefs.accent!=='any'?1:0}));
}
if(typeof customElements!=='undefined'&&!customElements.get('dj-jar-finder'))customElements.define('dj-jar-finder',class extends HTMLElement{
 connectedCallback(){
  if(this.bound)return;this.bound=true;this.dialog=this.querySelector('dialog');this.form=this.querySelector('form');this.words=JSON.parse(this.querySelector('[data-words]').textContent);this.step=0;this.resultOffset=0;
  this.products=[...this.querySelector('[data-catalog]').content.querySelectorAll('article')].map(e=>({id:e.dataset.id,title:e.dataset.title,url:e.dataset.url,image:e.dataset.image,price:Number(e.dataset.price),priceText:e.dataset.priceText,available:e.dataset.available==='true',colors:e.dataset.colors.split(',').filter(Boolean),contents:djfParseContents(e.dataset.description)}));
  this.refreshKinds();
  if(Number(this.dataset.page)>1)this.catalogReady=this.loadFirstCatalog();
  this.querySelector('[data-launch]').addEventListener('click',()=>this.open(true));this.querySelector('[data-start]').addEventListener('click',()=>this.showStep(1));
  this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close()));
  this.querySelector('[data-next]').addEventListener('click',()=>{if(!this.valid())return;if(this.step<3)this.showStep(this.step+1);else this.showResults()});
  this.querySelector('[data-back]').addEventListener('click',()=>this.showStep(Math.max(0,this.step-1)));
  this.querySelector('[data-other]').addEventListener('click',()=>{this.resultOffset+=3;this.showResults(true)});this.querySelector('[data-edit]').addEventListener('click',()=>this.showStep(1));this.querySelector('[data-restart]').addEventListener('click',()=>{this.form.reset();this.showStep(1)});
  this.form.addEventListener('submit',event=>{event.preventDefault();this.querySelector('[data-next]').click()});
  this.form.addEventListener('change',()=>{this.resultOffset=0;this.querySelector('[data-error]').hidden=true;this.refreshColors()});
  this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.querySelector('[data-launch]').focus({preventScroll:true})});
  this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close()});
  this.key='dj-jar-finder-v2';this.test=new URLSearchParams(location.search).get('dj_finder')==='1';
  let seen=false;try{seen=sessionStorage.getItem(this.key)==='1'}catch{}
  if(this.dataset.auto==='true'&&(!seen||this.test))this.timer=setTimeout(()=>this.autoOpen(),700);
 }
 autoOpen(){
  if(!this.isConnected)return;
  const blocking=[...document.querySelectorAll('dialog[open],[role="alertdialog"],[aria-modal="true"]')].some(e=>!this.contains(e)&&!e.closest('details:not([open]),[hidden],[aria-hidden="true"]')&&e.getBoundingClientRect().height>10&&e.checkVisibility({checkOpacity:true,checkVisibilityCSS:true}));
  if(document.hidden||blocking){this.timer=setTimeout(()=>this.autoOpen(),1500);return}this.open(false);
 }
 open(manual){if(this.dialog.open)return;clearTimeout(this.timer);this.showStep(0,false);this.previousOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';try{if(!this.test)sessionStorage.setItem(this.key,'1')}catch{}}
 showStep(step,focus=true){
  this.refreshColors();
  this.step=step;this.dialog.setAttribute('aria-labelledby',step?'djf-step-'+step:'djf-intro-heading');this.dialog.classList.toggle('djf-compact',step>0);this.dialog.classList.remove('djf-results');this.querySelector('[data-intro]').hidden=step!==0;this.form.hidden=step===0;this.querySelector('[data-results]').hidden=true;
  this.querySelectorAll('[data-step]').forEach(e=>e.hidden=Number(e.dataset.step)!==step);
  this.querySelector('[data-step-label]').textContent=this.words.progress.replace('[step]',step);this.querySelector('[data-progress]').style.width=`${step/3*100}%`;
  this.querySelector('[data-next-text]').textContent=step===3?this.words.results_button:this.words.next;
  this.querySelector('[data-error]').hidden=true;this.dialog.scrollTop=0;
  if(focus){const heading=step?this.querySelector(`[data-step="${step}"] h2`):this.querySelector('[data-intro] h2');heading.focus({preventScroll:true})}
 }
 refreshKinds(){
  const valid=this.products.filter(p=>p.available&&p.contents);
  this.querySelectorAll('[data-kind-option]').forEach(e=>{const kind=e.dataset.kindOption;e.hidden=!valid.some(p=>{const types=Object.keys(p.contents).filter(t=>p.contents[t].min>0);return kind==='mix'?types.length>1:types.length===1&&types[0]===kind})});
  const selected=this.form.querySelector('input[name="kind"]:checked');if(selected?.closest('[data-kind-option]').hidden){const first=[...this.querySelectorAll('[data-kind-option]')].find(e=>!e.hidden)?.querySelector('input');if(first)first.checked=true}
 }
 refreshColors(){
  const prefs={...this.preferences(),accent:'any',budget:Infinity};
  this.form.querySelectorAll('input[name="accent"]').forEach(input=>{
   input.disabled=input.value!=='any'&&!djfRank(this.products,{...prefs,accent:input.value}).length;
   if(input.disabled&&input.checked)this.form.querySelector('input[name="accent"][value="any"]').checked=true;
  });
 }
 async loadFirstCatalog(){
  try{const url=new URL(location.pathname,location.origin);url.searchParams.set('section_id',this.dataset.section);url.searchParams.set('page','1');const response=await fetch(url);if(!response.ok)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html');const template=doc.querySelector('[data-catalog]');if(!template)return;this.products=[...template.content.querySelectorAll('article')].map(e=>({id:e.dataset.id,title:e.dataset.title,url:e.dataset.url,image:e.dataset.image,price:Number(e.dataset.price),priceText:e.dataset.priceText,available:e.dataset.available==='true',colors:e.dataset.colors.split(',').filter(Boolean),contents:djfParseContents(e.dataset.description)}));this.refreshKinds();this.refreshColors()}catch{}
 }
 preferences(){const val=name=>this.form.querySelector(`input[name="${name}"]:checked`)?.value;return {kind:val('kind')||'mix',metal:val('metal')||'any',accent:val('accent')||'any',budget:Number(val('budget')||Infinity)}}
 valid(){return true}
 async showResults(other=false){
  if(this.catalogReady)await this.catalogReady;
  if(!other)this.resultOffset=0;
  const prefs=this.preferences();const all=djfRank(this.products,prefs);if(this.resultOffset>=all.length)this.resultOffset=0;const matches=all.slice(this.resultOffset,this.resultOffset+3);this.querySelector('[data-other]').hidden=all.length<=3;
  const w=this.words;this.form.hidden=true;this.querySelector('[data-intro]').hidden=true;this.querySelector('[data-results]').hidden=false;this.dialog.classList.add('djf-results','djf-compact');
  const heading=this.querySelector('[data-results-title]');heading.textContent=matches.length?w.results_title:w.no_title;this.dialog.setAttribute('aria-labelledby','djf-results-heading');this.querySelector('[data-results-text]').textContent=matches.length?w.results_text:w.no_text;
  const summary=[w['kind_'+prefs.kind]];if(prefs.metal!=='any')summary.push(w[prefs.metal]);if(prefs.accent!=='any')summary.push(w[prefs.accent]);if(Number.isFinite(prefs.budget))summary.push(w.up_to+' '+new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR',maximumFractionDigits:2}).format(prefs.budget/100));this.querySelector('[data-summary]').textContent=summary.join(' · ')||w.no_preferences;
  const cards=this.querySelector('[data-cards]');cards.replaceChildren();
  matches.forEach((p,index)=>{const card=document.createElement('article');card.className='djf-card';if(index===0){card.classList.add('djf-best');const badge=document.createElement('div');badge.className='djf-best-badge';badge.textContent=w.best_match;card.append(badge)}const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.width=400;img.height=480;img.loading='eager';card.append(img);const copy=document.createElement('div');copy.className='djf-card-copy';const title=document.createElement('h3');title.textContent=p.title;copy.append(title);const price=document.createElement('p');price.className='djf-price';price.textContent=p.priceText;copy.append(price);const reasons=document.createElement('p');reasons.className='djf-reasons';let why=[w['kind_'+prefs.kind]];if(prefs.metal!=='any'||prefs.accent!=='any')why.push(w.match_color+' '+[prefs.metal==='any'?'':w[prefs.metal],prefs.accent==='any'?'':w[prefs.accent]].filter(Boolean).join(' + '));if(Number.isFinite(prefs.budget))why.push(w.price_match);reasons.textContent=why.join(' · ')||w.all_types;copy.append(reasons);const list=document.createElement('ul');list.className='djf-contents';Object.entries(p.contents).forEach(([type,n])=>{if(n.max===0)return;const li=document.createElement('li');li.textContent=(n.min===n.max?n.min:n.min+'–'+n.max)+' '+(type==='earrings'?'paar '+w[type].toLowerCase():w[type].toLowerCase());list.append(li)});copy.append(list);const link=document.createElement('a');link.href=p.url;link.textContent=w.view+' ↗';copy.append(link);card.append(copy);cards.append(card)});
  this.querySelector('[data-pieces-note]').hidden=!matches.length;this.dialog.scrollTop=0;heading.focus({preventScroll:true});
 }
 disconnectedCallback(){clearTimeout(this.timer);if(this.dialog?.open)this.dialog.close()}
});
if(typeof module!=='undefined')module.exports={djfParseContents,djfRank};


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dj-jar-welcome"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dj-jar-welcome'))customElements.define('dj-jar-welcome',class extends HTMLElement{
  connectedCallback(){
    this.dialog=this.querySelector('dialog');if(!this.dialog||this.bound)return;this.bound=true;
    this.key='dj-jar-welcome-v1';this.test=new URLSearchParams(location.search).get('dj_popup')==='1'||this.dataset.preview==='true';
    this.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>this.dialog.close()));
    this.querySelector('[data-shop]').addEventListener('click',()=>{this.dialog.close();const grid=document.querySelector('#ProductGridContainer')||document.querySelector('#product-grid');if(grid){grid.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});grid.setAttribute('tabindex','-1');grid.focus({preventScroll:true})}});
    this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close()});
    this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||''});
    try{if(!this.test&&sessionStorage.getItem(this.key))return}catch{}
    this.timer=setTimeout(()=>this.openWhenReady(),this.test?700:Number(this.dataset.delay)*1000);
  }
  async openWhenReady(){
    if(!this.isConnected)return;
    if(document.hidden||[...document.querySelectorAll('dialog[open], [aria-modal="true"]:not(.dj-welcome)')].some(element=>!element.closest('details:not([open]),[hidden],[aria-hidden="true"]')&&element.getBoundingClientRect().height>10&&element.getBoundingClientRect().width>10&&element.checkVisibility({checkOpacity:true,checkVisibilityCSS:true}))){this.timer=setTimeout(()=>this.openWhenReady(),1500);return}
    const images=[...this.querySelectorAll('img')];images.forEach(image=>image.loading='eager');
    const ready=await Promise.all(images.map(image=>image.complete?Promise.resolve(image.naturalWidth>0):new Promise(resolve=>{image.addEventListener('load',()=>resolve(true),{once:true});image.addEventListener('error',()=>resolve(false),{once:true})})));if(ready.some(value=>!value)||!this.isConnected)return;
    this.previousOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';
    try{if(!this.test)sessionStorage.setItem(this.key,'1')}catch{}
  }
  disconnectedCallback(){clearTimeout(this.timer);if(this.dialog?.open)this.dialog.close()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
